import { useEffect } from 'react';
import { useCookieConsentContext } from '@/contexts/CookieConsentContext';

const GA_MEASUREMENT_ID = 'G-PNFPH35D90';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export function GoogleAnalytics() {
  const { isAnalyticsAllowed } = useCookieConsentContext();

  useEffect(() => {
    if (isAnalyticsAllowed) {
      // Check if script already exists
      if (document.getElementById('ga-script')) return;

      // Create and inject the gtag.js script
      const script = document.createElement('script');
      script.id = 'ga-script';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag(...args: unknown[]) {
        window.dataLayer.push(args);
      };
      window.gtag('js', new Date());
      window.gtag('config', GA_MEASUREMENT_ID, {
        anonymize_ip: true, // GDPR compliance - anonymize IP addresses
      });

      console.log('Google Analytics loaded with consent');
    } else {
      // Remove GA scripts and cookies if consent is revoked
      const existingScript = document.getElementById('ga-script');
      if (existingScript) {
        existingScript.remove();
        
        // Clear GA cookies
        const cookies = document.cookie.split(';');
        cookies.forEach((cookie) => {
          const name = cookie.split('=')[0].trim();
          if (name.startsWith('_ga') || name.startsWith('_gid') || name.startsWith('_gat')) {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          }
        });

        // Reset dataLayer
        window.dataLayer = [];
        
        console.log('Google Analytics removed - consent revoked');
      }
    }
  }, [isAnalyticsAllowed]);

  return null;
}
